const FALLBACK_CHUNK = 8 * 1024 * 1024;

const getConnection = () => {
  if (typeof navigator === "undefined") return null;
  return (
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection ||
    null
  );
};

export const chunkSizeForConnection = () => {
  const c = getConnection();
  if (!c) return FALLBACK_CHUNK;
  if (c.saveData) return 1 * 1024 * 1024;
  switch (c.effectiveType) {
    case "slow-2g":
    case "2g":
      return 512 * 1024;
    case "3g":
      return 2 * 1024 * 1024;
    case "4g":
      return 16 * 1024 * 1024;
    default:
      return FALLBACK_CHUNK;
  }
};

/**
 * @deprecated Do NOT pass this to `tus.Upload`'s `parallelUploads` option — that splits the
 * file into N partial uploads via the TUS Concatenation extension, whose partial POSTs strip
 * our custom Upload-Metadata and break ownership validation. Real per-file throughput in
 * tus-js-client is sequential by design (one chunk in flight per upload). Use
 * `parallelFilesForConnection` at the queue level for actual parallelism.
 */
export const parallelChunksForConnection = () => {
  const c = getConnection();
  if (!c || c.saveData) return 1;
  return c.effectiveType === "4g" ? 3 : 1;
};

// Pinned to 1: parallel file uploads cause concurrent TUS PATCH transactions in
// TusLifecycleService to race on `UploadMetadata.bytesUploaded`, triggering
// ObjectOptimisticLockingFailureException. Symptoms in production: noisy 5xx alerts
// and packages stuck at CHUNK_UPLOAD_IN_PROGRESS because a final-chunk transaction
// rolled back after the file was already physically assembled to disk.
//
// If you bring back parallelism (>1), you MUST first replace the read-modify-write
// on pkg.bytesUploaded with an atomic JPQL increment AND add a pessimistic lock
// around the maybePromotePackageToReady path — otherwise the same race reappears.
// Throughput cost of pinning to 1 is small for video-sized files (the typical case);
// upgrade only if a real workload shows it.
export const parallelFilesForConnection = () => 1;
